import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_RESUMEN_DESCARGA } from '../../../../../config/tables'

function DescargaDiariaView () {
  return (
    <MuiTable id={TABLA_RESUMEN_DESCARGA} />
  )
}

export default DescargaDiariaView
